<template>
  <VLayout :title="$t('login.box_title')" :subtitle="$t('login.subtit')">
    <VLogin v-on:login-done="onLoginDone" />
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import VLogin from "@/components/LoginForm";

import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapState({
      patientSelected: state => state.naturalperson.patientSelected,
    }),
  },
  watch: {
    isAuthenticated: function(newAuthState) {
      if (newAuthState && this.patientSelected) {
        this.$router.push({
          name: "userhome",
          params: { pt_uuid: this.patientSelected.uuid },
        });
      }
    },
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.isAuthenticated && this.patientSelected) {
        this.$router.push({
          name: "userhome",
          params: { pt_uuid: this.patientSelected.uuid },
        });
      }
    });
  },
  methods: {
    onLoginDone(data) {
      if (data.error) {
        return;
      }
      // Si al realizar login correctamente, el usuario no tiene
      // paciente, redireccionamos al form de crear uno.
      if (!data.pt_uuid) {
        return this.$router.push({
          name: "patientdata",
        });
      }
      // Si se ha indicado expresamente una url de vuelta, vamos ahí
      if (this.$route.params["backto"]) {
        return this.$router.push(this.$route.params["backto"]);
      }
      // En otro caso, nos movemos a la página de usuario
      this.$router.push({
        name: "userhome",
        params: { pt_uuid: data.pt_uuid },
      });
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        login: {
          box_title: "Login",
          subtit:
            "Welcome to your private area as a patient user of the MEDIKA Online platform.",
        },
      },
    },
  },
  components: {
    VLayout,
    VLogin,
  },
};
</script>

<style lang="scss">
</style>
